/**
 * @generated SignedSource<<8d5ad60b0eab7e4552638d48fbaa87a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarSource = "google" | "internal" | "office365";
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type MeetingAttachmentProvider = "GOOGLE" | "ZOOM";
export type ResponseStatusChoices = "accepted" | "declined" | "needsAction" | "none" | "notResponded" | "organizer" | "tentative" | "tentativelyAccepted";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
export type UserType = "ADMIN" | "BOT" | "GUEST" | "MEMBER";
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type ViewEventDetailQuery$variables = {
  guid?: string | null;
};
export type ViewEventDetailQuery$data = {
  readonly event: {
    readonly attachments: ReadonlyArray<{
      readonly fileId: string;
      readonly fileType: string;
      readonly provider: MeetingAttachmentProvider;
      readonly title: string | null;
      readonly url: string;
    }> | null;
    readonly attendees: ReadonlyArray<{
      readonly __typename: "Attendee";
      readonly email: string;
      readonly fullName: string | null;
      readonly image: string | null;
      readonly invitable: boolean;
      readonly isOptional: boolean | null;
      readonly isOrganizer: boolean | null;
      readonly responseStatus: ResponseStatusChoices | null;
      readonly title: string | null;
      readonly user: {
        readonly id: string;
        readonly isTopUser: boolean;
      } | null;
    } | null>;
    readonly calendar: {
      readonly color: string | null;
      readonly id: string;
      readonly name: string | null;
      readonly source: CalendarSource;
      readonly sourcePrimary: boolean;
    };
    readonly conferenceCalls: ReadonlyArray<{
      readonly phoneNumber: string | null;
      readonly pin: string | null;
      readonly provider: ConferenceCallProvider;
      readonly url: string;
    }>;
    readonly description: string | null;
    readonly id: string;
    readonly isOneOnOne: boolean;
    readonly location: string | null;
    readonly nextOccurrence: {
      readonly calendar: {
        readonly id: string;
      };
      readonly conferenceCalls: ReadonlyArray<{
        readonly provider: ConferenceCallProvider;
        readonly url: string;
      }>;
      readonly guid: string;
      readonly id: string;
      readonly isAllDay: boolean;
      readonly start: string | null;
      readonly status: StatusChoices;
      readonly timeBlockType: string | null;
      readonly willBeRecorded: WillBeRecordedType;
    } | null;
    readonly note: {
      readonly assignedTodoCount: number;
      readonly attachments: ReadonlyArray<{
        readonly dimensions: {
          readonly height: number;
          readonly width: number;
        } | null;
        readonly filename: string;
        readonly filetype: string;
        readonly id: string;
        readonly size: number | null;
        readonly updatedAt: string | null;
        readonly url: string;
      }>;
      readonly createdAt: string | null;
      readonly eventStart: string | null;
      readonly externalUsers: ReadonlyArray<{
        readonly __typename: "User";
        readonly email: string;
        readonly firstName: string;
        readonly fullName: string;
        readonly id: string;
        readonly image: string;
        readonly internalAttributes: {
          readonly invitable: boolean;
        } | null;
        readonly isActive: boolean;
        readonly isConfigured: boolean;
        readonly isExternal: boolean;
        readonly isGuest: boolean;
        readonly isTopUser: boolean;
        readonly type: UserType;
      }> | null;
      readonly id: string;
      readonly meetingRecordings: ReadonlyArray<{
        readonly id: string;
        readonly meetingCallStart: string;
        readonly meetingRecordedVideoDuration: number | null;
        readonly meetingRecordedVideoPosterUrl: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"utils_AddedOrAvailableUntil_meetingRecording" | "utils_useLongestMeetingRecording_meetingRecordings">;
      }> | null;
      readonly noteuserSet: ReadonlyArray<{
        readonly id: string;
        readonly lastSeenAt: string | null;
        readonly user: {
          readonly __typename: "User";
          readonly email: string;
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly image: string;
          readonly internalAttributes: {
            readonly invitable: boolean;
          } | null;
          readonly isActive: boolean;
          readonly isConfigured: boolean;
          readonly isExternal: boolean;
          readonly isGuest: boolean;
          readonly isTopUser: boolean;
          readonly type: UserType;
        };
      }>;
      readonly rawDraftJson: any;
      readonly title: string;
      readonly updatedAt: string | null;
      readonly url: string | null;
    } | null;
    readonly previousOccurrence: {
      readonly note: {
        readonly pendingAgendaCount: number;
        readonly pendingTodoCount: number;
      } | null;
    } | null;
    readonly recurrenceRule: ReadonlyArray<string | null> | null;
    readonly requiredSectionsCount: number;
    readonly status: StatusChoices;
    readonly stream: {
      readonly carryActionItems: boolean | null;
      readonly carryTalkingPoints: boolean | null;
      readonly id: string;
      readonly schedulingMeetingAssistantAutomationIsActive: boolean;
      readonly template: {
        readonly id: string;
        readonly proseDoc: any;
        readonly schemaVersion: number;
      } | null;
    } | null;
    readonly userResponseStatus: ResponseStatusChoices | null;
    readonly userTodos: ReadonlyArray<{
      readonly done: boolean;
    } | null> | null;
  } | null;
  readonly viewer: {
    readonly account: {
      readonly defaultBasicTemplate: {
        readonly id: string;
        readonly proseDoc: any;
        readonly schemaVersion: number;
      } | null;
      readonly defaultMeetingTemplate: {
        readonly id: string;
        readonly proseDoc: any;
        readonly schemaVersion: number;
      } | null;
      readonly defaultOneononeTemplate: {
        readonly id: string;
        readonly proseDoc: any;
        readonly schemaVersion: number;
      } | null;
      readonly id: string;
    };
    readonly remainingMeetingRecordingCredits: number;
    readonly " $fragmentSpreads": FragmentRefs<"RecordingRow_viewer">;
  };
};
export type ViewEventDetailQuery = {
  response: ViewEventDetailQuery$data;
  variables: ViewEventDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "guid"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingMeetingRecordingCredits",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "proseDoc",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "schemaVersion",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteTemplateNode",
  "kind": "LinkedField",
  "name": "defaultMeetingTemplate",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteTemplateNode",
  "kind": "LinkedField",
  "name": "defaultOneononeTemplate",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteTemplateNode",
  "kind": "LinkedField",
  "name": "defaultBasicTemplate",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v7 = [
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOneOnOne",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userResponseStatus",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "image",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invitable",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTopUser",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Attendee",
  "kind": "LinkedField",
  "name": "attendees",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOptional",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrganizer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v18/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ConferenceCall",
  "kind": "LinkedField",
  "name": "conferenceCalls",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pin",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingAttachment",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": true,
  "selections": [
    (v20/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileId",
      "storageKey": null
    },
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileType",
      "storageKey": null
    },
    (v17/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "done",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Calendar",
  "kind": "LinkedField",
  "name": "calendar",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sourcePrimary",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiredSectionsCount",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "carryActionItems",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "carryTalkingPoints",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "schedulingMeetingAssistantAutomationIsActive",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteTemplateNode",
      "kind": "LinkedField",
      "name": "template",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingTodoCount",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pendingAgendaCount",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventStart",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedTodoCount",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawDraftJson",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenAt",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConfigured",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isGuest",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v44 = [
  (v12/*: any*/),
  (v2/*: any*/),
  (v38/*: any*/),
  (v13/*: any*/),
  (v39/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/),
  (v18/*: any*/),
  (v43/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserInternalAttributes",
    "kind": "LinkedField",
    "name": "internalAttributes",
    "plural": false,
    "selections": [
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Attachment",
  "kind": "LinkedField",
  "name": "attachments",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filetype",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "size",
      "storageKey": null
    },
    (v33/*: any*/),
    (v21/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageDimensions",
      "kind": "LinkedField",
      "name": "dimensions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "width",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "height",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingCallStart",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoDuration",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetingRecordedVideoPosterUrl",
  "storageKey": null
},
v49 = [
  (v2/*: any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "nextOccurrence",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "guid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "willBeRecorded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    (v25/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAllDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeBlockType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConferenceCall",
      "kind": "LinkedField",
      "name": "conferenceCalls",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v21/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Calendar",
      "kind": "LinkedField",
      "name": "calendar",
      "plural": false,
      "selections": (v49/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = [
  (v12/*: any*/),
  (v2/*: any*/),
  (v38/*: any*/),
  (v13/*: any*/),
  (v39/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/),
  (v18/*: any*/),
  (v43/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "UserInternalAttributes",
    "kind": "LinkedField",
    "name": "internalAttributes",
    "plural": false,
    "selections": [
      (v16/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewEventDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RecordingRow_viewer"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "event",
        "args": (v7/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v19/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userTodos",
            "plural": true,
            "selections": [
              (v24/*: any*/)
            ],
            "storageKey": null
          },
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "previousOccurrence",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v17/*: any*/),
              (v21/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v44/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "externalUsers",
                "plural": true,
                "selections": (v44/*: any*/),
                "storageKey": null
              },
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "meetingRecordings",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "utils_useLongestMeetingRecording_meetingRecordings"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "utils_AddedOrAvailableUntil_meetingRecording"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v50/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewEventDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "primaryAdmin",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountRecordingCredits",
                "kind": "LinkedField",
                "name": "recordingCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedAiMeetingCredits",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSubscriptionActive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionState",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionBillingCycleAnchor",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAdminAccess",
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "event",
        "args": (v7/*: any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventByGuid",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v19/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "userTodos",
            "plural": true,
            "selections": [
              (v12/*: any*/),
              (v24/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v49/*: any*/),
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "previousOccurrence",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "kind": "LinkedField",
            "name": "note",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v17/*: any*/),
              (v21/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NoteUser",
                "kind": "LinkedField",
                "name": "noteuserSet",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v37/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v51/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "externalUsers",
                "plural": true,
                "selections": (v51/*: any*/),
                "storageKey": null
              },
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecording",
                "kind": "LinkedField",
                "name": "meetingRecordings",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  (v48/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingCallEnd",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingAndTranscriptWillBeDeleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "transcriptDeletionReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "meetingRecordingVideoDeletionReason",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recordingDataAutoDeletionDate",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v50/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "06d98cbcfdfa27d54f626a2b4d04755a",
    "id": null,
    "metadata": {},
    "name": "ViewEventDetailQuery",
    "operationKind": "query",
    "text": "query ViewEventDetailQuery(\n  $guid: String\n) {\n  viewer {\n    remainingMeetingRecordingCredits\n    account {\n      id\n      defaultMeetingTemplate {\n        id\n        proseDoc\n        schemaVersion\n      }\n      defaultOneononeTemplate {\n        id\n        proseDoc\n        schemaVersion\n      }\n      defaultBasicTemplate {\n        id\n        proseDoc\n        schemaVersion\n      }\n    }\n    ...RecordingRow_viewer\n    id\n  }\n  event: eventByGuid(guid: $guid) {\n    id\n    isOneOnOne\n    description\n    recurrenceRule\n    userResponseStatus\n    attendees {\n      __typename\n      email\n      fullName\n      image\n      invitable\n      title\n      responseStatus\n      isOptional\n      isOrganizer\n      user {\n        id\n        isTopUser\n      }\n    }\n    conferenceCalls {\n      provider\n      url\n      phoneNumber\n      pin\n    }\n    attachments {\n      provider\n      fileId\n      url\n      fileType\n      title\n    }\n    userTodos {\n      __typename\n      done\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    status\n    location\n    calendar {\n      id\n      source\n      name\n      color\n      sourcePrimary\n    }\n    requiredSectionsCount\n    stream {\n      id\n      carryActionItems\n      carryTalkingPoints\n      schedulingMeetingAssistantAutomationIsActive\n      template {\n        id\n        proseDoc\n        schemaVersion\n      }\n    }\n    previousOccurrence {\n      note {\n        pendingTodoCount\n        pendingAgendaCount\n        id\n      }\n      id\n    }\n    note {\n      id\n      title\n      url\n      eventStart\n      updatedAt\n      createdAt\n      assignedTodoCount\n      rawDraftJson\n      noteuserSet {\n        id\n        lastSeenAt\n        user {\n          __typename\n          id\n          type\n          email\n          firstName\n          fullName\n          image\n          isActive\n          isConfigured\n          isGuest\n          isTopUser\n          isExternal\n          internalAttributes {\n            invitable\n            id\n          }\n        }\n      }\n      externalUsers {\n        __typename\n        id\n        type\n        email\n        firstName\n        fullName\n        image\n        isActive\n        isConfigured\n        isGuest\n        isTopUser\n        isExternal\n        internalAttributes {\n          invitable\n          id\n        }\n      }\n      attachments {\n        id\n        filename\n        filetype\n        size\n        updatedAt\n        url\n        dimensions {\n          width\n          height\n        }\n      }\n      meetingRecordings {\n        id\n        meetingCallStart\n        meetingRecordedVideoDuration\n        meetingRecordedVideoPosterUrl\n        ...utils_useLongestMeetingRecording_meetingRecordings\n        ...utils_AddedOrAvailableUntil_meetingRecording\n      }\n    }\n    nextOccurrence {\n      id\n      guid\n      willBeRecorded\n      start\n      status\n      isAllDay\n      timeBlockType\n      conferenceCalls {\n        provider\n        url\n      }\n      calendar {\n        id\n      }\n    }\n  }\n}\n\nfragment RecordingRowOutOfCreditsWarning_viewer on Viewer {\n  hasAdminAccess\n  account {\n    primaryAdmin {\n      fullName\n      id\n    }\n    recordingCredits {\n      includedAiMeetingCredits\n      id\n    }\n    billingAccount {\n      isSubscriptionActive\n      subscriptionState\n      subscriptionBillingCycleAnchor\n      id\n    }\n    id\n  }\n}\n\nfragment RecordingRow_viewer on Viewer {\n  remainingMeetingRecordingCredits\n  ...RecordingRowOutOfCreditsWarning_viewer\n}\n\nfragment utils_AddedOrAvailableUntil_meetingRecording on MeetingRecording {\n  meetingCallEnd\n  recordingAndTranscriptWillBeDeleted\n  transcriptDeletionReason\n  meetingRecordingVideoDeletionReason\n  recordingDataAutoDeletionDate\n}\n\nfragment utils_useLongestMeetingRecording_meetingRecordings on MeetingRecording {\n  meetingCallStart\n  meetingCallEnd\n  meetingRecordedVideoDuration\n}\n"
  }
};
})();

(node as any).hash = "1101ca0a3cc8308aeda9c81501b89f8d";

export default node;
